export var getDisplayName = element => {
  var _element$type;
  return (// @ts-expect-error
    element === null || element === void 0 ? void 0 : (_element$type = element.type) === null || _element$type === void 0 ? void 0 : _element$type.displayName
  );
};
//# sourceMappingURL=index.js.map